import {
  leTabs,
  leEllipsis,
  leFilter,
  leBubble,
  leSelect,
  leToggle,
  leButton,
  leTable,
  leListPlusPreview,
  leInputField,
} from 'lp-vue-components';
import GeneralIcon from '@components/common/icons/general-icon';
import ToggleSelectionIcon from '@components/common/icons/toggle-selection-icon';
import ListPlusPreview from '@components/common/list-plus-preview';
import TimeDuration from '@components/common/time-duration';

const components = [
  leTabs, leEllipsis, leFilter, leBubble, leSelect, leToggle, leButton, leTable, leListPlusPreview, leInputField,
  GeneralIcon, ToggleSelectionIcon, ListPlusPreview, TimeDuration,
];

export function registerComponents(Vue) {
  components.forEach(component => Vue.component(component.name, component));
}
